export const discountTimelineV1023 = (assignments, now = Date.now() / 1000) => {
  // Server statuses avoid workstation clock skew. Legacy responses still have
  // a deterministic presentation, without changing the server's CAS authority.
  const hasStatus = assignments.some((row) => row.status);
  const current = hasStatus
    ? assignments.find((row) => row.status === 'current')
    : assignments
        .filter((row) => row.effective_period_start <= now)
        .sort((a, b) => b.effective_period_start - a.effective_period_start)[0];
  return {
    current,
    rows: assignments.map((row) => ({
      ...row,
      status:
        row.status ||
        (row.effective_period_start > now
          ? 'pending'
          : row.id === current?.id
          ? 'current'
          : 'historical'),
    })),
  };
};
